module.exports = __webpack_public_path__ + "static/assets/0dcd27b60c185811b19f59d56eaa12f6.mp3";